export default __webpack_public_path__ + "static/media/dropzone.98adadbd.svg";